var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.22,14.14c-1.06,0-1.98,.64-2.39,1.55l-3.79-2.38c.22-.38,.35-.83,.35-1.31s-.13-.94-.37-1.33l3.81-2.36c.41,.91,1.33,1.55,2.39,1.55,1.44,0,2.61-1.17,2.61-2.61s-1.17-2.61-2.61-2.61c-1.23,0-2.26,.85-2.54,1.99l-4.83,3c-.33-.16-.69-.24-1.07-.24-1.44,0-2.61,1.17-2.61,2.61s1.17,2.61,2.61,2.61c.39,0,.77-.09,1.1-.25l4.81,3.01c.28,1.14,1.31,1.99,2.53,1.99,1.44,0,2.61-1.18,2.61-2.61s-1.17-2.61-2.61-2.61Zm0-8.5c.89,0,1.61,.72,1.61,1.61s-.72,1.61-1.61,1.61-1.61-.72-1.61-1.61,.72-1.61,1.61-1.61ZM6.17,12c0-.89,.72-1.61,1.61-1.61s1.61,.72,1.61,1.61-.72,1.61-1.61,1.61-1.61-.72-1.61-1.61Zm10.05,6.36c-.89,0-1.61-.73-1.61-1.61s.72-1.61,1.61-1.61,1.61,.72,1.61,1.61-.72,1.61-1.61,1.61Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/Share-Icon.d31aedc5cc7be012949593b5a56df40f.svg";
export { ForwardRef as ReactComponent };